module.exports = __webpack_public_path__ + "static/media/trash.cbc9229b.svg";